import constants from './constants';

export const initialState = {
  claims: [],
  isClaimDetailsOpen: false,
  claimDetails: {},
  pagination: {
    totalElements: 0
  },
  member: {},
  requestParams: {},
  error: null,
  claimDetailsLoading: false,
  claimDetailsError: null,
  claimsYouOwe: [],
  claimBenefits: null
};

export const claimsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.SET_CLAIM_DETAILS_BEGIN: {
      return {
        ...state,
        claimDetailsLoading: true,
        claimDetailsError: null
      };
    }
    case constants.SET_CLAIMS_YOU_OWE: {
      return {
        ...state,
        claimsYouOwe: [...payload]
      };
    }
    case constants.SET_CLAIMS_CLEANUP:
      return initialState;
    case constants.SET_CLAIM_DETAILS_SUCCESS: {
      return {
        ...state,
        claimDetails: { ...payload },
        claimDetailsLoading: false,
        claimDetailsError: null
      };
    }
    case constants.SET_CLAIM_DETAILS_ERROR: {
      return {
        ...state,
        claimDetails: {},
        claimDetailsLoading: false,
        claimDetailsError: payload.error
      };
    }
    case constants.SET_CLAIMS_ERROR:
      return {
        ...state,
        error: payload
      };
    case constants.SET_CLAIM_DETAIL_BENEFITS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };

    case constants.SET_CLAIM_DETAIL_BENEFITS_SUCCESS:
      return {
        ...state,
        claimBenefits: payload.data,
        loading: false
      };

    case constants.SET_CLAIM_DETAIL_BENEFITS_ERROR:
      return {
        ...state,
        claimBenefits: {},
        loading: false,
        error: payload.error
      };

    case constants.SET_CLAIM_DETAIL_BENEFITS_CLEANUP:
      return {
        ...state,
        claimBenefits: null,
        loading: false
      };
    case constants.SET_CLAIMS: {
   

      return {
        ...state,
        claims: payload.content ? [...payload.content] : [],
        pagination: {
          ...payload.pageable,
          ...payload.sort,
          empty: payload.empty,
          firstPage: payload.first,
          lastPage: payload.last,
          totalElements: payload.totalElements,
          totalPages: payload.totalPages
        },
        member: { ...payload.member },
        requestParams: { ...payload.requestParams }
      };
    }

    default:
      return state;
  }
};
